import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { id: "work-history" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Work Period"),
    /*#__PURE__*/_createElementVNode("th", null, "Production"),
    /*#__PURE__*/_createElementVNode("th", null, "Employer"),
    /*#__PURE__*/_createElementVNode("th", null, "Local"),
    /*#__PURE__*/_createElementVNode("th", null, "Fund"),
    /*#__PURE__*/_createElementVNode("th", null, "Work Reported"),
    /*#__PURE__*/_createElementVNode("th", null, "Credited")
  ])
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { colspan: "7" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "hidden"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  style: {"background-color":"white","height":"170px"}
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "subtotal" }
const _hoisted_19 = { colspan: "4" }
const _hoisted_20 = { class: "subtotal-cell" }
const _hoisted_21 = { class: "cell" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "cell" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { class: "cell" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  class: "text-center"
}, " No results found. ", -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("tr", { class: "total-divider" }, null, -1)
const _hoisted_35 = {
  key: 1,
  class: "total sm-mb-20"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grand-total-cell" }, "Grand Total Contributions")
], -1)
const _hoisted_37 = { class: "cell" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "cell" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { class: "cell" }
const _hoisted_46 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_5, [
                _createVNode(_component_LoaderComponent)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.Years, (yearDetail, year) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: year }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearDetail.Results, (result, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: result.ParticipantWHID
                  }, [
                    _createElementVNode("tr", {
                      class: _normalizeClass({ 'page-break': (index + 1) % 20 === 0 })
                    }, [
                      _createElementVNode("td", null, _toDisplayString(result.WorkPeriod), 1),
                      _createElementVNode("td", null, _toDisplayString(result.Production), 1),
                      _createElementVNode("td", null, _toDisplayString(result.Employer), 1),
                      _createElementVNode("td", null, _toDisplayString(result.Local), 1),
                      _createElementVNode("td", null, _toDisplayString(result.Plan), 1),
                      _createElementVNode("td", null, [
                        (parseFloat(result.DaysWorked) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                              _createTextVNode(_toDisplayString(result.DaysWorked) + " Days ", 1),
                              _hoisted_8
                            ]))
                          : _createCommentVNode("", true),
                        (parseFloat(result.HoursWorked) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                              _createTextVNode(_toDisplayString(result.HoursWorked) + " Hours ", 1),
                              _hoisted_10
                            ]))
                          : _createCommentVNode("", true),
                        (parseFloat(result.EarningsReported) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                              _createTextVNode(_toDisplayString(_ctx.formatCurrency(result.EarningsReported)) + " Contractual Wages", 1),
                              _hoisted_12
                            ]))
                          : _createCommentVNode("", true),
                        (parseFloat(result.ContractWages) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                              _createTextVNode(_toDisplayString(_ctx.formatCurrency(result.ContractWages)) + " Gross Wages", 1),
                              _hoisted_14
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(result.ContributionsPaid), 1)
                    ], 2),
                    ((index + 1) % 20 === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_15, _hoisted_17))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _createElementVNode("tr", _hoisted_18, [
                  _createElementVNode("td", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, "Total Contributions for " + _toDisplayString(year), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearDetail.YearTotals, (amount, fundID) => {
                        return (_openBlock(), _createElementBlock("p", { key: fundID }, [
                          (amount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.getFundName(fundID)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_23, [
                      (yearDetail.UnitTotals)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (yearDetail.UnitTotals.TotalDays > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(yearDetail.UnitTotals.TotalDays) + " Days", 1))
                              : _createCommentVNode("", true),
                            (yearDetail.UnitTotals.Hours > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(yearDetail.UnitTotals.Hours) + " Hours ", 1))
                              : _createCommentVNode("", true),
                            (yearDetail.UnitTotals.TotalEarnings > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.formatCurrency(yearDetail.UnitTotals.TotalEarnings)) + " Contractual Wages ", 1))
                              : _createCommentVNode("", true),
                            (yearDetail.UnitTotals.TotalWages > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.formatCurrency(yearDetail.UnitTotals.TotalWages)) + " Gross Wages ", 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearDetail.YearTotals, (amount, fundID) => {
                        return (_openBlock(), _createElementBlock("p", { key: fundID }, [
                          (amount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.formatCurrency(amount)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ], 64))
            }), 128)),
            (!Object.values(_ctx.data.Years)?.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_31, _hoisted_33))
              : _createCommentVNode("", true),
            _hoisted_34,
            (_ctx.data.GrandTotals)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.GrandTotals, (amount, fundID) => {
                        return (_openBlock(), _createElementBlock("p", { key: fundID }, [
                          (amount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.getFundName(fundID)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_39, [
                      (_ctx.data.GrandTotalUnits)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (_ctx.data.GrandTotalUnits.TotalDays > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.data.GrandTotalUnits.TotalDays) + " Days", 1))
                              : _createCommentVNode("", true),
                            (_ctx.data.GrandTotalUnits.Hours > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.data.GrandTotalUnits.Hours) + " Hours", 1))
                              : _createCommentVNode("", true),
                            (_ctx.data.GrandTotalUnits.TotalEarnings > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.formatCurrency(_ctx.data.GrandTotalUnits.TotalEarnings)) + " Contractual Wages ", 1))
                              : _createCommentVNode("", true),
                            (_ctx.data.GrandTotalUnits.TotalWages > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.formatCurrency(_ctx.data.GrandTotalUnits.TotalWages)) + " Gross Wages ", 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.GrandTotals, (amount, fundID) => {
                        return (_openBlock(), _createElementBlock("p", { key: fundID }, [
                          (amount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.formatCurrency(amount)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}